module.exports = __webpack_public_path__ + "media/images/team/HelenaMoreira-e0b72be65b3c59cda81c3a6b96b82647.png";